import * as React from "react"
import type { SVGProps } from "react"
const SvgAppStoreFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M16.29 20.71q.29.3.71.29a1 1 0 0 0 .71-.27q.3-.28.29-.7V18h2q.42 0 .71-.29.3-.29.29-.71a1 1 0 0 0-.27-.71 1 1 0 0 0-.7-.29H18v-2q0-.42-.29-.71A1 1 0 0 0 17 13a1 1 0 0 0-.71.28 1 1 0 0 0-.29.7V16h-2q-.42 0-.71.29-.3.29-.29.71 0 .42.28.71.27.3.7.29H16v2q0 .42.29.71"
    />
    <path d="M14 11a1 1 0 0 1-.71-.29A1 1 0 0 1 13 10V4q0-.42.29-.71.29-.3.71-.29h6q.42 0 .71.29.3.29.29.71v6q0 .42-.29.71-.29.3-.71.29z" />
    <path
      fillRule="evenodd"
      d="M3.29 10.71q.29.3.71.29h6q.42 0 .71-.29.3-.29.29-.71V4q0-.42-.29-.71A1 1 0 0 0 10 3H4q-.42 0-.71.29-.3.29-.29.71v6q0 .42.29.71M4 21a1 1 0 0 1-.71-.29A1 1 0 0 1 3 20v-6q0-.42.29-.71.29-.3.71-.29h6q.42 0 .71.29.3.29.29.71v6q0 .42-.29.71-.29.3-.71.29z"
    />
  </svg>
)
export default SvgAppStoreFilled
